import { render, staticRenderFns } from "./ColumnsEdit.vue?vue&type=template&id=6e2e983c&scoped=true"
import script from "./ColumnsEdit.vue?vue&type=script&lang=ts"
export * from "./ColumnsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e983c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2e983c')) {
      api.createRecord('6e2e983c', component.options)
    } else {
      api.reload('6e2e983c', component.options)
    }
    module.hot.accept("./ColumnsEdit.vue?vue&type=template&id=6e2e983c&scoped=true", function () {
      api.rerender('6e2e983c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mongoviews/ColumnsEdit.vue"
export default component.exports